import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Pathurl from "../Class/Pathurl.json";
import { Class_ETC_SessionTimeOut , Class_ETC_Logout } from "../Class/Class_Etc";
import { CP_CheckPermission } from "../Class/Class_Permission";

function LeftMenu() {

  const pathname = useLocation().pathname.toLowerCase();
  const [isLoadedConfigData, setIsLoadedConfigData] = useState(false);
  const [isLoadedpermission, setIsLoadedpermission] = useState(true);
  const [configData, setConfigData] = useState([]);

  useEffect(() => {
    if (isLoadedpermission === true) {
      GetConfig();
      if (isLoadedConfigData === true) {

        let token = "";
        token = localStorage.getItem("TStoken");
        if (token === null || token === "")
        {
          setIsLoadedpermission(false);
          //ไม่เจอ Token ให้โดดไปหน้า login ทันที !!
          Class_ETC_Logout();
        }
        else {
          Check_Permission(function () {
            setIsLoadedpermission(false);
          });
        }
      }
    }
    // eslint-disable-next-line
  }, [isLoadedConfigData]);

  async function GetConfig() {
    await fetch("../ConfigData.json")
      .then((res) => res.json())
      .then((data) => {
        setConfigData(data);
        setIsLoadedConfigData(true);
      })
      .catch((err) => err);
  }

  async function Check_Permission(_callback) {
    try {
      let token = "";
      token = localStorage.getItem("TStoken");
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        token: token.trim(),
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        configData.API_URL + "Permission_Get",
        requestOptions
      );
      const json = await response.json();
      if (json.status_ID === 1) {
        localStorage.setItem("per_menu_main", json.per_menu_main);
        localStorage.setItem("per_menu_master", json.per_menu_master);
        localStorage.setItem("per_menu_report", json.per_menu_report);
        localStorage.setItem("workday_WT", json.workday_WT);
        if (_callback != null) {
          _callback();
        }
      } else {
        Class_ETC_SessionTimeOut();
      }
    } catch {
      Class_ETC_SessionTimeOut();
    }
  }

  const com_img_display = localStorage.getItem("com_img_display");
  const default_display = "../images/Logo/Quiksheet_logo.png";
  const Left_logo = com_img_display !== "" ? com_img_display : default_display;

  
  const isPsTimesheets = CP_CheckPermission("main",["my_timesheets_view"],false,false); 
  const isPsApprove = CP_CheckPermission("main", ["approve_view"], false, false); 
  const isPsClearing = CP_CheckPermission("main",["clearing_view"],false,false); 
  const isPsProjects = CP_CheckPermission("main",["projects_view"],false,false);
  const isPsRpProject = CP_CheckPermission("report",["report_project_view"],false,false); 
  const isPsRpStaffs = CP_CheckPermission("report",["report_staffs_view"],false,false); 
  const isPsRpTasks = CP_CheckPermission("report",["report_tasks_view"],false,false); 
  const isPsRpPosition = CP_CheckPermission("report",["report_position_view"],false,false); 
  const isPsRpTransaction = CP_CheckPermission("report",["report_transaction_view"],false,false);
  const isPsRpTimesheetbyperiod = CP_CheckPermission("report",["report_timesheetbyperiod_view"],false,false);
  const isPsRpTimesheetbystaff  = CP_CheckPermission("report",["report_timesheetbystaff_view"],false,false);


  const isPsCustomer = CP_CheckPermission("master",["customers_view"],false,false); 
  const isPsStaff = CP_CheckPermission("master", ["staff_view"], false, false); 
  const isPsDepartment = CP_CheckPermission("master",["department_view"],false,false); 
  const isPsPosition = CP_CheckPermission("master",["position_view"],false,false); 
  const isPsTask = CP_CheckPermission("master", ["task_view"], false, false); 
  const isPsTimeoff = CP_CheckPermission("master",["time_off_view"],false,false); 
  const isPsHoliday = CP_CheckPermission("master",["holiday_view"],false,false); 
  const isPsCompany = CP_CheckPermission("master",["configuration_view"],false,false); 
  const isPsPermission = CP_CheckPermission("master",["permission_group_view"],false,false);
 
  const isPsServiceinfo = CP_CheckPermission("master",["service_info_view"],false,false);


  const supportsystem = localStorage.getItem("supportsystem");
  const isService_department = CP_CheckPermission("service_list",["department"],false,false);


  return (
    <>
      {/* Main Sidebar Container */}
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        {/* Brand Logo */}
        {isLoadedpermission && (
          <div
            id="divLoadingProgress"
            name="divLoadingProgress"
            align="center"
            className="divWaiting"
          >
            <img alt="progress" src="../dist/img/loading.gif" />
          </div>
        )}

        <a href="#!" className="brand-link">
          <img
            src={Left_logo}
            alt="Flashwork Logo"
            className="brand-image"
          />
          <span className="brand-text font-weight  text-center">
            QUIK SHEET{" "}
          </span>
        </a>
        {/* Sidebar */}
        <div className="sidebar">
          {/* Sidebar Menu */}
          <nav className="mt-2">
            <ul
              className="nav nav-pills nav-sidebar flex-column  nav-child-indent nav-collapse-hide-child"
              data-widget="treeview"
              role="menu"
              data-accordion="false"
            >
              {/* Add icons to the links using the .nav-icon class with font-awesome or any other icon font library */}

              {(isPsTimesheets === true ||
                isPsApprove === true ||
                isPsClearing === true) && (
                <li className="nav-header">MAIN NAVIGATION</li>
              )}

              {isPsTimesheets === true && (
                <li className="nav-item">
                  <a
                    href={"../" + Pathurl.timesheet}
                    className={
                      pathname === "/" + Pathurl.timesheet.toLowerCase()
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="nav-icon fas fa-table" />
                    <p> My Time sheet</p>
                  </a>
                </li>
              )}

              {isPsApprove === true && (
                <li className="nav-item">
                  <a
                    href={"../" + Pathurl.approveTimesheet}
                    className={
                      pathname === "/" + Pathurl.approveTimesheet.toLowerCase()
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="nav-icon fas fa-chalkboard-teacher"></i>
                    <p> Approve</p>
                  </a>
                </li>
              )}

              {isPsClearing === true && (
                <li className="nav-item">
                  <a
                    href={"../" + Pathurl.clearingTimesheet}
                    className={
                      pathname === "/" + Pathurl.clearingTimesheet.toLowerCase()
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="nav-icon fas fa-check-double"></i>
                    <p> Clearing</p>
                  </a>
                </li>
              )}

              {(isPsProjects === true) && (
                <>
                  <li className="nav-header p-0">
                    <hr className="bg-gray" />
                  </li>
                  <li className="nav-item">
                    <a
                      href={"../" + Pathurl.m_projectSearch}
                      className={
                        pathname ===
                          "/" + Pathurl.m_projectSearch.toLowerCase() ||
                        pathname === "/" + Pathurl.m_project_ae.toLowerCase() ||
                        pathname === "/" + Pathurl.m_project_view.toLowerCase()
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon far fa-building" />
                      <p>Projects</p>
                    </a>
                  </li>
                </>
              )}

              {(isPsRpProject === true ||
                isPsRpStaffs === true ||
                isPsRpTasks === true ||
                isPsRpPosition === true ||
                isPsRpTransaction === true ||
                isPsRpTimesheetbyperiod === true ||
                isPsRpTimesheetbystaff === true
                ) && (
                <>
                  <li className="nav-header p-0">
                    <hr className="bg-gray" />
                  </li>
                </>
              )}
              {(isPsRpProject === true ||
                isPsRpStaffs === true ||
                isPsRpTasks === true ||
                isPsRpPosition === true ||
                isPsRpTransaction === true || 
                isPsRpTimesheetbyperiod === true ||
                isPsRpTimesheetbystaff === true
                ) && (
                <>
                  <li className="nav-header">ANALYZE</li>
                </>
              )}
              {(isPsRpProject === true ||
                isPsRpStaffs === true ||
                isPsRpTasks === true ||
                isPsRpPosition === true ||
                isPsRpTransaction === true ||
                isPsRpTimesheetbyperiod === true ||
                isPsRpTimesheetbystaff === true
                ) && (
                <>
                  <li
                    className={
                      pathname ===
                        "/" + Pathurl.report_sumByProject.toLowerCase() ||
                      pathname ===
                        "/" + Pathurl.report_sumByStaff.toLowerCase() ||
                      pathname ===
                        "/" + Pathurl.report_sumByTasks.toLowerCase() ||
                      pathname ===
                        "/" + Pathurl.report_sumByPosition.toLowerCase() ||
                      pathname ===
                        "/" + Pathurl.report_sumByTransaction.toLowerCase() ||
                      pathname ===
                          "/" + Pathurl.report_Timesheetbyperiod.toLowerCase() ||
                      pathname ===
                      "/" + Pathurl.report_sumByTimeSheetByStaff.toLowerCase() 
                        ? "nav-item menu-is-opening menu-open"
                        : "nav-item"
                    }
                  >
                    <a
                      href="#!"
                      className={
                        pathname ===
                          "/" + Pathurl.report_sumByProject.toLowerCase() ||
                        pathname ===
                          "/" + Pathurl.report_sumByStaff.toLowerCase() ||
                        pathname ===
                          "/" + Pathurl.report_sumByTasks.toLowerCase() ||
                        pathname ===
                          "/" + Pathurl.report_sumByPosition.toLowerCase() ||
                        pathname ===
                          "/" + Pathurl.report_sumByTransaction.toLowerCase()||
                        pathname ===
                          "/" + Pathurl.report_Timesheetbyperiod.toLowerCase() ||
                        pathname ===
                          "/" + Pathurl.report_sumByTimeSheetByStaff.toLowerCase()
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-chart-bar" />
                      <p>
                        Report
                        <i className="right fas fa-angle-left" />
                      </p>
                    </a>
                    <ul className="nav nav-treeview">
                      {isPsRpProject === true && (
                        <li className="nav-item ">
                          <a
                            href={"../" + Pathurl.report_sumByProject}
                            className={
                              pathname ===
                              "/" + Pathurl.report_sumByProject.toLowerCase()
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                            <i className="far fa-circle nav-icon" />
                            <p>Project report</p>
                          </a>
                        </li>
                      )}
                      {isPsRpStaffs === true && (
                        <li className="nav-item">
                          <a
                            href={"../" + Pathurl.report_sumByStaff}
                            className={
                              pathname ===
                              "/" + Pathurl.report_sumByStaff.toLowerCase()
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                            <i className="far fa-circle nav-icon" />
                            <p>Staffs report</p>
                          </a>
                        </li>
                      )}
                      {isPsRpTasks === true && (
                        <li className="nav-item">
                          <a
                            href={"../" + Pathurl.report_sumByTasks}
                            className={
                              pathname ===
                              "/" + Pathurl.report_sumByTasks.toLowerCase()
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                            <i className="far fa-circle nav-icon" />
                            <p>Tasks report</p>
                          </a>
                        </li>
                      )}
                      {isPsRpPosition === true && (
                        <li className="nav-item">
                          <a
                            href={"../" + Pathurl.report_sumByPosition}
                            className={
                              pathname ===
                              "/" + Pathurl.report_sumByPosition.toLowerCase()
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                            <i className="far fa-circle nav-icon"></i>
                            <p>Position report</p>
                          </a>
                        </li>
                      )}
                      {isPsRpTransaction === true && (
                        <li className="nav-item">
                          <a
                            href={"../" + Pathurl.report_sumByTransaction}
                            className={
                              pathname ===
                              "/" +
                                Pathurl.report_sumByTransaction.toLowerCase()
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                            <i className="far fa-circle nav-icon"></i>
                            <p>Transaction report</p>
                          </a>
                        </li>
                      )}

                      {isPsRpTimesheetbyperiod === true && (
                        <li className="nav-item">
                          <a
                            href={"../" + Pathurl.report_Timesheetbyperiod}
                            className={
                              pathname ===
                              "/" +
                                Pathurl.report_Timesheetbyperiod.toLowerCase()
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                            <i className="far fa-circle nav-icon"></i>
                            <p>Timesheet By Period report</p>
                          </a>
                        </li>
                      )}
                      
                      {isPsRpTimesheetbystaff === true && (
                        <li className="nav-item">
                          <a
                            href={"../" + Pathurl.report_sumByTimeSheetByStaff}
                            className={
                              pathname ===
                              "/" +
                                Pathurl.report_sumByTimeSheetByStaff.toLowerCase()
                                ? "nav-link active"
                                : "nav-link"
                            }
                          >
                            <i className="far fa-circle nav-icon"></i>
                            <p>TimeSheet By Staff report</p>
                          </a>
                        </li>
                      )}



                    </ul>
                  </li>
                </>
              )}
              {(isPsCustomer === true ||
                isPsStaff === true ||
                isPsDepartment === true ||
                isPsPosition === true ||
                isPsTask === true ||
                isPsTimeoff === true ||
                isPsHoliday === true ||
                isPsCompany === true ||
                isPsPermission === true ||
                isPsServiceinfo === true
                ) && (
                <>
                  <li className="nav-header p-0">
                    <hr className="bg-gray" />
                  </li>
                  <li className="nav-header">BACKEND</li>
                </>
              )}
              {isPsCustomer === true && (
                <li className="nav-item">
                  <a
                    href={"../" + Pathurl.m_customer}
                    className={
                      pathname === "/" + Pathurl.m_customer.toLowerCase() ||
                      pathname === "/" + Pathurl.m_customer_view.toLowerCase()
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="nav-icon far fa-user-circle" />
                    <p>Customers</p>
                  </a>
                </li>
              )}
              {isPsStaff === true && (
                <li className="nav-item">
                  <a
                    href={"../" + Pathurl.m_staff}
                    className={
                      pathname === "/" + Pathurl.m_staff.toLowerCase()
                        ? "nav-link active"
                        : pathname === "/" + Pathurl.m_staff_ae.toLowerCase()
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="nav-icon fa fa-users" />
                    <p>Staff</p>
                  </a>
                </li>
              )}
              {((isPsDepartment === true && isService_department === true) ||
                isPsPosition === true ||
                isPsTask === true ||
                isPsTimeoff === true ||
                isPsHoliday === true) && (
                <li
                  className={
                    "nav-item " +
                    (pathname === "/" + Pathurl.m_department.toLowerCase() ||
                    pathname === "/" + Pathurl.m_position.toLowerCase() ||
                    pathname === "/" + Pathurl.m_position_ae.toLowerCase() ||
                    pathname === "/" + Pathurl.m_task.toLowerCase() ||
                    pathname === "/" + Pathurl.m_timeoff.toLowerCase() ||
                    pathname === "/" + Pathurl.m_holiday.toLowerCase()
                      ? "menu-is-opening menu-open"
                      : "")
                  }
                >
                  <a
                    href="#!"
                    className={
                      "nav-link " +
                      (pathname === "/" + Pathurl.m_department.toLowerCase() ||
                      pathname === "/" + Pathurl.m_position.toLowerCase() ||
                      pathname === "/" + Pathurl.m_position_ae.toLowerCase() ||
                      pathname === "/" + Pathurl.m_task.toLowerCase() ||
                      pathname === "/" + Pathurl.m_timeoff.toLowerCase() ||
                      pathname === "/" + Pathurl.m_holiday.toLowerCase()
                        ? "active"
                        : "")
                    }
                  >
                    <i className="nav-icon fas fa-cogs"></i>
                    <p>
                      SETTING
                      <i className="right fas fa-angle-left"></i>
                    </p>
                  </a>
                  <ul className="nav nav-treeview">
                    {(isPsDepartment === true && isService_department === true) && (
                      <li className="nav-item">
                        <a
                          href={"../" + Pathurl.m_department}
                          className={
                            pathname ===
                            "/" + Pathurl.m_department.toLowerCase()
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="nav-icon fas fa-cubes" />
                          <p>Department</p>
                        </a>
                      </li>
                    )}
                    {isPsPosition === true && (
                      <li className="nav-item">
                        <a
                          href={"../" + Pathurl.m_position}
                          className={
                            pathname === "/" + Pathurl.m_position.toLowerCase()
                              ? "nav-link active"
                              : pathname ===
                                "/" + Pathurl.m_position_ae.toLowerCase()
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="nav-icon fas fa-graduation-cap" />
                          <p>Position</p>
                        </a>
                      </li>
                    )}
                    {isPsTask === true && (
                      <li className="nav-item">
                        <a
                          href={"../" + Pathurl.m_task}
                          className={
                            pathname === "/" + Pathurl.m_task.toLowerCase()
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="nav-icon fas fa-tasks" />
                          <p>Task</p>
                        </a>
                      </li>
                    )}
                    {isPsTimeoff === true && (
                      <li className="nav-item">
                        <a
                          href={"../" + Pathurl.m_timeoff}
                          className={
                            pathname === "/" + Pathurl.m_timeoff.toLowerCase()
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="nav-icon fas fa-unlink" />
                          <p>Time off</p>
                        </a>
                      </li>
                    )}
                    {isPsHoliday === true && (
                      <li className="nav-item">
                        <a
                          href={"../" + Pathurl.m_holiday}
                          className={
                            pathname === "/" + Pathurl.m_holiday.toLowerCase()
                              ? "nav-link active"
                              : "nav-link"
                          }
                        >
                          <i className="nav-icon fas fa-suitcase" />
                          <p>Holiday</p>
                        </a>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {isPsCompany === true && (
                <li className="nav-item">
                  <a
                    href={"../" + Pathurl.m_configuration}
                    className={
                      pathname === "/" + Pathurl.m_configuration.toLowerCase()
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="nav-icon fas fa-wrench" />
                    <p>Company Setting</p>
                  </a>
                </li>
              )}
              {isPsPermission === true && (
                <li className="nav-item ">
                  <a
                    href={"../" + Pathurl.m_permission}
                    className={
                      pathname === "/" + Pathurl.m_permission.toLowerCase()
                        ? "nav-link active"
                        : pathname ===
                          "/" + Pathurl.m_permission_ae.toLowerCase()
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="nav-icon fas fa-lock" />
                    <p>Permission Group</p>
                  </a>
                </li>
              )}
              {isPsServiceinfo === true && (
                <li className="nav-item ">
                  <a
                    href={"../" + Pathurl.m_serviceinfo}
                    className={
                      pathname === "/" + Pathurl.m_serviceinfo.toLowerCase()
                        ? "nav-link active"
                        : "nav-link"
                    }
                  >
                    <i className="nav-icon fas fa-info-circle" />
                    <p>Service Info</p>
                  </a>
                </li>
              )}
              {supportsystem === "allowcom0" && 
                <>
                  <li className="nav-header p-0"><hr className="bg-gray" /></li>
                  <li className="nav-item ">
                    <a
                      href={"../" + Pathurl.m_company}
                      className={
                        pathname === "/" + Pathurl.m_company.toLowerCase()||
                        pathname === "/" + Pathurl.m_company_ae.toLowerCase() 
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-store-alt" />
                      <p>Company List</p>
                    </a>
                  </li>
                  <li className="nav-item ">
                    <a
                      href={"../" + Pathurl.m_announcement}
                      className={
                        pathname === "/" + Pathurl.m_announcement.toLowerCase() 
                          ? "nav-link active"
                          : "nav-link"
                      }
                    >
                      <i className="nav-icon fas fa-bullhorn" />
                      <p>Announcement</p>
                    </a>
                  </li>
                </>
              }
            </ul>
          </nav>
          {/* /.sidebar-menu */}
        </div>
        {/* /.sidebar */}
      </aside>
    </>
  );
}

export default LeftMenu;
